import { mapActions, mapState } from 'vuex'
import { getDistance } from '../helpers/getDistance'

export const sortDeliverySpotsByDistance = {
  data () {
    return {
      availableSpots: null,
      disabledSpots: null,
      isMapMoved: false
    }
  },
  computed: {
    ...mapState({
      exactUserLocation: state => state.geoLocation.exactUserLocation,
      isCityFromGeoSelected: state => state.geoLocation.isCityFromGeoSelected,
      map: state => state.map.map
    })
  },
  methods: {
    ...mapActions(['SET_CITY_FROM_GEO_SELECTED_ACTION']),
    distanceFilter (spots, center, isMoving) {
      if (!this.isCityFromGeoSelected && !isMoving) return spots
      spots && spots.sort((spot1, spot2) => {
        return getDistance(center.latitude, center.longitude, spot1.latitude, spot1.longitude) -
          getDistance(center.latitude, center.longitude, spot2.latitude, spot2.longitude)
      })
      return spots
    },
    isCityFromGeo (userGeo, spot) {
      return getDistance(userGeo.latitude, userGeo.longitude, spot.latitude, spot.longitude) < 50
    },
    sortDeliverySpotsByDistance (ar) {
      let idx = 0
      let filteredSpots
      const clone = ar.slice()

      if (this.mailName === 'novaPoshtaWarehouse') {
        const disabledSpots = ar.filter((el, i) => {
          if (!+el.isAvailable) {
            clone.splice(i - idx, 1)
            idx++
          }
          if (this.exactUserLocation && this.isCityFromGeo(this.exactUserLocation, el) && !this.isCityFromGeoSelected) {
            this.SET_CITY_FROM_GEO_SELECTED_ACTION(true)
          }
          return !+el.isAvailable
        })
        this.availableSpots = clone
        this.disabledSpots = disabledSpots
        filteredSpots = [...this.distanceFilter(clone, this.exactUserLocation), ...disabledSpots]
      } else if (this.mailName === 'pickup') {
        const disabledSpots = ar.filter((el, i) => {
          if (el?.status === 0 || (el?.status === 4 && el?.quantity < 1)) {
            clone.splice(i - idx, 1)
            idx++
          }
          if (this.exactUserLocation && this.isCityFromGeo(this.exactUserLocation, el) && !this.isCityFromGeoSelected) {
            this.SET_CITY_FROM_GEO_SELECTED_ACTION(true)
          }
          return el?.status === 0 || (el?.status === 4 && el?.quantity < 1)
        })

        this.availableSpots = clone
        this.disabledSpots = disabledSpots
        filteredSpots = [...this.distanceFilter(clone, this.exactUserLocation), ...disabledSpots]
      } else {
        clone.sort((el1, el2) => {
          if (this.exactUserLocation && this.isCityFromGeo(this.exactUserLocation, el1) && !this.isCityFromGeoSelected) {
            this.SET_CITY_FROM_GEO_SELECTED_ACTION(true)
          }
          return +el1.uid - +el2.uid
        })
        filteredSpots = this.distanceFilter(clone, this.exactUserLocation)
      }
      return filteredSpots
    },
    dragEnd () {
      const coords = this.map.getCenter()
      const params = { latitude: coords.lat(), longitude: coords.lng() }
      if (this.mailName === 'novaPoshtaWarehouse' || this.mailName === 'pickup') {
        this.spotsInfo = [...this.distanceFilter(this.availableSpots, params, true), ...this.disabledSpots]
      } else {
        this.spotsInfo = this.distanceFilter(this.spotsInfo, params, true)
      }
    },
    dragStart () {
      this.isMapMoved = true
    }
  }
}
